import { useState, useEffect } from "react";
import { Button } from "../components/ui/button";
import { Menu, X } from "lucide-react";
import { useEmailCapture } from "../components/EmailCaptureProvider";

export const Header = () => {
  const { openModal } = useEmailCapture();
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header role="banner">
      <nav
        data-testid="header"
        aria-label="Main navigation"
        className={`sticky top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? "bg-white shadow-lg py-2" : "bg-white/95 backdrop-blur-sm py-3"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
          {/* Empty space */}
          <div className="w-32"></div>

          <div className="hidden md:flex items-center gap-6">
            <button onClick={openModal} className="text-[#4A5043] hover:text-[#FF6B00] font-medium transition-colors text-sm">
              How It Works
            </button>
            <button onClick={openModal} className="text-[#4A5043] hover:text-[#FF6B00] font-medium transition-colors text-sm">
              Benefits
            </button>
            <button onClick={openModal} className="text-[#4A5043] hover:text-[#FF6B00] font-medium transition-colors text-sm">
              Reviews
            </button>
            <button onClick={openModal} className="text-[#4A5043] hover:text-[#FF6B00] font-medium transition-colors text-sm">
              FAQ
            </button>
          </div>

          <div className="flex items-center gap-3">
            <Button 
              onClick={openModal}
              data-testid="header-cta"
              className="hidden md:inline-flex bg-gradient-to-r from-[#FF6B00] to-[#FF8C00] hover:from-[#E65C00] hover:to-[#FF6B00] text-white font-bold rounded-full px-6 py-2 shadow-lg hover:shadow-xl transition-all duration-300 animate-pulse"
            >
              Order Now - Save 80%
            </Button>
            <button
              data-testid="mobile-menu-toggle"
              className="md:hidden p-2"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-white border-t border-gray-100 p-6 space-y-4 shadow-xl">
            <button onClick={() => { openModal(); setMobileMenuOpen(false); }} className="block w-full text-left text-lg text-[#4A5043] hover:text-[#FF6B00]">How It Works</button>
            <button onClick={() => { openModal(); setMobileMenuOpen(false); }} className="block w-full text-left text-lg text-[#4A5043] hover:text-[#FF6B00]">Benefits</button>
            <button onClick={() => { openModal(); setMobileMenuOpen(false); }} className="block w-full text-left text-lg text-[#4A5043] hover:text-[#FF6B00]">Reviews</button>
            <button onClick={() => { openModal(); setMobileMenuOpen(false); }} className="block w-full text-left text-lg text-[#4A5043] hover:text-[#FF6B00]">FAQ</button>
            <Button 
              onClick={() => { openModal(); setMobileMenuOpen(false); }}
              className="w-full bg-gradient-to-r from-[#FF6B00] to-[#FF8C00] text-white font-bold rounded-full py-3"
            >
              Order Now - Save 80%
            </Button>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
